import { gql } from "@apollo/client";

export default gql`
  mutation trashComplianceProgramCalibrationGroup($id: Int!) {
    deleteCalibrationGroup(id: $id) {
      ok
    }
  }
`;
